module.exports = __webpack_public_path__ + "img/baloto-icon.274f3890.svg";